import clsx from 'clsx'
import type { ReactNode } from 'react'
import { Tooltip } from './Tooltip'

/**
 * Explains why the control inside is disabled. While `reason` is set, the
 * wrapper takes the pointer and joins the tab order, which a disabled control
 * leaves. Pass a reason only while the control is disabled.
 */
export function DisabledReason({
  reason,
  children,
  className,
  align,
  placement,
  fullWidth,
}: {
  reason: ReactNode
  children: ReactNode
  className?: string
  align?: 'left' | 'right'
  placement?: 'default' | 'right-start' | 'right'
  fullWidth?: boolean
}) {
  const explains = reason !== null && reason !== undefined && reason !== false && reason !== ''

  return (
    <Tooltip
      variant="label"
      content={reason}
      focusable={explains}
      align={align}
      placement={placement}
      fullWidth={fullWidth}
      className={clsx(
        explains && 'cursor-not-allowed [&_:disabled]:pointer-events-none',
        className
      )}
    >
      {children}
    </Tooltip>
  )
}
